// Material Kit 2 React pages
import Products from "pages/LandingPages/Products";

export default function ProductsPage() {
  return <Products />;
}
